import {  Trash2, Check } from 'lucide-react';

const NotificationItem = ({ notification, onMarkAsRead, onDelete }) => {
  return (
    <div className={`p-3 border-b hover:bg-gray-50 ${notification.read ? 'bg-gray-50' : 'bg-white'}`}>
      <div className="flex items-start">
        <div className="flex-grow">
          <p className="text-sm font-medium text-gray-800">{notification.title}</p>
          <p className="text-xs text-gray-500">{notification.message}</p>
          <p className="text-xs text-gray-400 mt-1">{notification.time}</p>
        </div>
        <div className="flex space-x-1">
          {!notification.read && (
            <button 
              onClick={() => onMarkAsRead(notification.id)} 
              className="p-1 text-blue-500 hover:text-blue-700"
              title="Marquer comme lu"
            >
              <Check className="w-4 h-4" />
            </button>
          )}
          <button 
            onClick={() => onDelete(notification.id)} 
            className="p-1 text-red-500 hover:text-red-700"
            title="Supprimer"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;